<template>
<!-- 
  Author: sss
  Date: 2021-10-18
  content: 首页
 -->
  <div>
    <navigation></navigation>
    <!--封面-->
    <section class="first-page main">
      <div class="wrap vb100">
        <div class="video-bg">
          <video id="video" src="https://vbdata-fe-static.oss-cn-beijing.aliyuncs.com/public/video/short_batch.mp4?versionId=CAEQFxiBgMC0o4.q6hciIDQ2OTk4NzFhMmJmMTRlNDZiZTJjYTI0YTYyMzBlYzgx" autoplay muted loop></video>
          <div class="mask" id="mask">
            <div class="title"><img src="~/img/main/index/title.png"></div>
            <!-- <links></links> -->
          </div>
        </div>
      </div>
    </section>
    <!--介绍-->
    <section class="second-page main">
      <div class="list-content">
        <div class="info" id="info">
          <div class="list-title">未来医疗100强榜介绍</div>
          <div class="main-title scorll-title animate__fadeInTopLeft" id="vbTitle">
            <img src="~/img/main/index/title_blue.png" class="title2">
            <img src="~/img/main/index/concept.png" alt="" class="concept">
          </div>
        </div>
      </div>
      <div class="second-content">
        <div class="introduce">
          <div class="introduce-image">
            <img src="~/img/main/index/introduce1.png" alt="">
          </div>
          <div class="introduce-words">
            <p>创立于2015年的未来医疗100强榜是由<br/>动脉网、VB100、蛋壳研究院推出的<br/>国内第一个针对非上市企业的创新医疗领域榜单，<br/>旨在遴选真正代表未来医疗的中国创新医疗者，<br/>推动健康医疗产业的创新变革进程。<br/>六年来，未来医疗100强榜单体系不断丰富，<br/>逐步构建形成面向企业、投资机构、医院、产业园区<br/>全球性创新医疗健康生态榜单。</p>
          </div>
        </div>
      </div>
      
    </section>
    <!--百强企业动态-->
    <section class="third-page main">
      <div class="list-content">
        <img class="right-img" src="~/img/main/index/introduce2.png" alt="">
        <div class="info">
          <div class="list-title">百强企业动态</div>
          <div class="trends"><img src="~/img/main/index/trends.png" alt=""></div>
        </div>
        <div class="trends-content">
          <div class="tags">
            <span v-for="item in article_type_list" :key="item.id" :class="active == item.id ? 'active' : ''" @click="changeStatus(item.id)">{{item.name}}</span>
          </div>
          <div class="result">
            <div class="result-tr">
              <div class="result-td" v-for="(item, index) in article_list" :key="item.article_id">
                <div class="td-content">
                  <p class="index-name">{{getArticleIndex(index + 1)}}</p>
                  <p class="company-name over-p1">{{item.short_name}}</p>
                  <img :src="getLogo(item.article_logo_path)" alt="暂无" class="logo">
                  <a :href="'http://vcbeat.top/'+ item.article_id" target="_blank" style="color: #333333">
                    <p class="article-title over-p2">{{item.article_title}}</p>
                  </a>
                  <p class="article-info over-p2">{{item.article_summary}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--百位人物专访-->
    <section class="fourth-page main">
      <div class="interview-content">
        <div class="list-content">
          <div class="info">
            <div class="list-title">百强人物专访</div>
            <div class="trends words"><img src="~/img/main/index/interview.png" alt=""></div>
          </div>
          <div class="interview-content">
            <div class="interview-tr" v-for="item in people_list" :key="item.id" v-show=" item.peopley.length > 0">
              <div class="people-type list-content"><span class="type-name">{{item.name}}</span></div>
              <div class="interview-wrapper wrap">
                <div class="interview-td"  v-for="people,index in item.peopley" :key="people.name" v-show="index > 7 ? not_show : show">
                  <div class="photo">
                    <img :src="getLogo(people.people_logo_path)">
                    <p class="detail" v-show="people.article_title != null">
                      <b>相关专访<i class="el-icon-right"></i></b>
                      <span class="title">{{people.article_title}}
                        <a class="more" :href="'http://vcbeat.top/' + people.article_id" target="_blank">查看更多</a>
                      </span>
                    </p>
                  </div>
                  <p class="people-name">{{people.people_name}}</p>
                  <p class="people-job">{{people.forum_display_title ? people.forum_display_title : people.en_forum_display_title}}</p>
                </div>
              </div>
              <div v-if="item.peopley.length > 8"><el-button class="be-fold"  @click="changeFold(!getIsFold)">{{ getIsFold ? '收起' : '展开'}}<i :class="getIsFold ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i></el-button></div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <footerDIV></footerDIV>
  </div>
</template>
<script>
import navigation from '@/components/navigation.vue'
import footerDIV from '@/components/footer.vue'
// import links from '@/components/links.vue'
import moren_img from '@/assets/img/main/index/moren.png'
import { getCompanyNewsList, getVbArticleType, getPeopleVisit } from '@/service/main.js'
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  name: 'Index',
  data() {
    return {
      active: 1,
      article_list: [],
      article_type_list: [],
      people_list: [],
      not_show: false,
      show: true
    }
  },
  components: { navigation, footerDIV, swiper, swiperSlide},
  mounted(){
    this.getVbArticleType()
    this.getPeopleVisit()
    // this.listenVideo()
  },
  computed: {
    getLogo() {
      return function(logo_path) {
        return logo_path ? this.$store.state.img_req_url + logo_path : moren_img 
      }
    },
    getArticleIndex() {
      return function(index) {
        if(index < 10) return 'TRENDS/' + '0' + index
        else return 'TRENDS/' + index
      }
    },
    getIsFold () {
      return this.not_show && this.show
    }
  },
  methods: {
    //展开收起人物动态
    changeFold(flag) {
      // flag 为true时展开 为false 时收起
      if (flag) this.not_show = true
      else this.not_show = false
    },
    //获取文章类型
    async getVbArticleType(){
      let res = await getVbArticleType({}, (error) => { this.$Message.error('请求错误') })
      if (res.status == 'success') {
        this.article_type_list = res.res
        this.active = res.res[0].id
        this.getCompanyNewsList()
      }
    },
    //企业动态
    async getCompanyNewsList() {
      let res = await getCompanyNewsList({article_type_id: this.active}, (error) => { this.$Message.error('请求错误') })
      if (res.status == 'success') this.article_list = res.res
    },
    // 人物动态
    async getPeopleVisit () {
      let res = await getPeopleVisit({}, (error) => { this.$Message.error('请求错误') })
      if (res.status == 'success') this.people_list = res.res
    },
    changeStatus(id) {
      this.active = id
      this.getCompanyNewsList()
    },
    listenVideo () {
      let v = document.getElementById('video')
      let app = document.getElementById('app')
      app.addEventListener('click', function() {
        v.play()
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
// @import '../../assets/css/main/common.stylus';
@import '../../assets/css/main/list.stylus';
.spanFont
  display inline-block
  width 100px
  height 18px
  font-size 14px
  font-weight bold
  color #FFFFFF
  line-height 22px
  padding-top 5px
  padding-bottom 7px
.spanActive
  border 1px solid #D9BB9E
  border-radius 18px
  color #D9BB9E
  text-align center
  margin-right 30px
.list-content 
  margin-top 0
  padding-top 80px
.first-page
  .wrap
    overflow hidden
    width 100%
    height 100vh
    .video-bg
      display flex
      justify-content center
      align-items center
      position relative
      margin-top 64px
      video
        width 100vw
      .mask
        position absolute
        width 100%
        height 100vh
        top 0
        background rgba(0,0,0, .3)
        .title
          position absolute
          top 50%
          left 50%
          transform translate(-50%,-50%)
          img
            // animation imageOpacity 3s linear 1 both
            width 13.5416vw
.words
  width 46.3542vw
  img 
    width 100%
.second-page
  .list-content
    .info
      flex-direction column
      .main-title
        margin-top 50px
        display flex
        align-items center
        .title2
          width 25.9375vw
        .concept
          width 46.3541vw
  .second-content
    width 77.7vw
    margin 60px auto 0
    padding-bottom 172px
    .introduce
      display flex
      justify-content space-between
      position relative
      margin-top 50px
      .introduce-image
        width 39.5833vw
        img 
          width 100%
      .introduce-words
        // width 31vw
        p
          font-weight 500
          // color #0C142E
          color #FFFFFF
          font-size 18px
          line-height 36px
.third-page
  color #ffffff
  .list-content
    width 100%
    display flex
    flex-direction column
    align-items center
    width 88%
    margin unset !important
    background-color #1F2330
    position relative
    .right-img
      position absolute
      right 0
      top -24vh
      // width 20vw
      height 44vh
    .info
      display flex
      align-items center
      width 1200px
      position relative
      left 7.88vw
      .trends
        margin-right auto
        margin-left -70px
        img
          width 39.4270vw
    .trends-content
      display flex
      flex-wrap wrap
      justify-content center
      // width 88%
      margin-top 47px
      position relative
      left 7.88vw
      .tags
        width 1200px
        span
          @extend.spanFont
          &:hover
            cursor pointer
        .active 
          @extend.spanActive
      .result
        width 1200px
        .result-tr
          width 100%
          display flex
          flex-wrap wrap
          margin-bottom 50px
          .result-td
            width 33%
            padding-bottom 10px
            margin-top 40px
            display flex
            .td-content
              width 242px
              line-height 22px
              font-weight bold
              .index-name
                font-size 14px
              .company-name
                font-size 20px
                margin-top 20px
              .logo
                width 100%
                height 152px
                margin-top 20px
              .article-title
                font-size 16px
                margin-top 5px
                color #FFFFFF
                &:hover
                  color #D9BB9E
              .article-info
                font-size 12px
                font-weight 500
                margin-top 20px
.fourth-page
  background #181A23
  .info
    align-items flex-end
.interview-tr
  &:last-child
    padding-bottom 60px
  // padding-bottom 45px
  .type-name
    @extend.spanFont
    @extend.spanActive
  .list-content
    padding-top 60px
  .be-fold
    width 100%
    margin-top 20px
    border none
    background none
    color #D9BB9E
  .interview-wrapper
    width 100%
    display flex
    flex-wrap wrap
    // justify-content center
    .interview-td
      margin-top 30px
      width 260px
      overflow hidden
      margin-right calc((1200px - 260px * 4)/3)
      .photo
        position relative
        height 361px
        overflow hidden
        display flex 
        justify-content center
        img
          height 361px
          object-fit cover
        .detail
          position absolute
          width 100%
          height 361px
          left 0
          top 330px
          font-size 12px
          color #FFFFFF
          padding 0
          margin 0
          line-height 16px
          transition all 0.5s ease-in-out
          overflow hidden
          text-overflow ellipsis
          -webkit-box-orient vertical
          -webkit-line-clamp 3
          b
            display block
            font-size 13px
            color #fff
            line-height 32px
            height 32px
            padding-left 5px
            background linear-gradient(90deg, #D9BB9E, #C78E66)
            .el-icon-right
              float right
              font-size 13px
              line-height 32px
              margin-right 5px
          .title 
            display block
            padding 10px 
            height 92px
            font-size 14px
            font-weight 500
            color #FFFFFF
            line-height 24px
            margin-top 220px
            .more
              display block
              font-size 12px
              font-weight 500
              color #D9BB9E
              line-height 22px
        &:hover
          .detail
            top 0
            background-color rgba(0,0,0,0.6)
          .el-icon-right::before
            content "\e6eb"
      .people-name
        font-size 20px
        // color #333333
        color #FFFFFF
        line-height 24px
        // margin-top 10px
        margin-top 20px
      .people-job
        font-size 14px
        font-weight 500
        // color #999999
        color #E9E9EB
        line-height 18px
        margin-top 13px
    .interview-td:nth-child(4n)
      margin-right 0
@keyframes imageOpacity {
  from {opacity: 0}
  to {opacity: 1}
}
</style>